/**
 * Task action rows shown beneath the Data Analysis card.
 *
 * Each action is a pure descriptor: title, description copy, an optional
 * Spark illustration path (resolved via sparkAssetUrl in ActionRowCard), and
 * the legacy `moveToScreen` route key the cards navigate to with the active
 * task type's `usecase._id`. Defining them here keeps `ActionRowList` purely
 * presentational and lets other surfaces (e.g. onboarding bars) reference the
 * same metadata without duplication.
 *
 * Order matches the Figma top-to-bottom ordering exactly.
 */
export const TASK_ACTIONS = [
    {
        id: 'model-configuration',
        title: 'Model Configuration',
        description:
            'Define how the model should behave. Select the base model, write the prompt, and set the interpreter logic.',
        illustration: 'illustrations/Illustration-Box-Closed.png',
        screenKey: 'model-setup',
    },
    {
        id: 'data-editor',
        title: 'Data Editor',
        description:
            'Improve model quality through annotation. Edit or label data to correct gaps and strengthen learning signals.',
        illustration: 'illustrations/Illustration-Cylinder.png',
        screenKey: 'data-selection',
    },
    {
        id: 'training',
        title: 'Training',
        description:
            'Finalize your training setup. Check the summary, select compute resources, and choose what metric to optimize.',
        illustration: 'illustrations/Illustration-Book-2.png',
        screenKey: 'train',
    },
    {
        id: 'evaluations',
        title: 'Evaluations',
        description:
            'See real performance, not guesses. Review metrics and compare your model with other internal or external models.',
        illustration: 'illustrations/Illustration-Tokens-2.png',
        screenKey: 'evaluation-from-session',
    },
];
